import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "../../../../Uri";
import {
  Container,
  Grid,
  Typography,
  InputLabel,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import Textfield from "./TextField";
import Select from "./Select";
import Gender from "./Gender";
import state from "./State";
import DateTimePicker from "./DataTimePicker";
import Button from "./Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomizedButtons from "./OccupancyButton";
const useStyles = makeStyles({
  root: {
    height: 35,
  },
  size: {
    width: 40,
    height: 30,
  },
});
const regular = "Regular";
const OneMonth = "OneMonth";
const daily = "Daily";
let bid = null;
const FORM_VALIDATION = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^[aA-zZ\s]+$/, "Invalid FirstName ")
    .required("Required"),
  fatherName: Yup.string().matches(/^[aA-zZ\s]+$/, "Invalid LastName "),
  email: Yup.string().email("Invalid email."),
  checkInDate: Yup.date()
    .test(
      "Check In Date",
      "Please choose a valid Check In Date 🥱🥳",
      (date) => moment().diff(moment(date), "days") <= 15
      // moment(date).format("DD-MM-YYYY") >= moment(new Date()).format("DD-MM-YYYY")
    )
    .required("Required"),
  bloodGroup: Yup.string().matches(/^(A|B|AB|O)[+-]$/, {
    message: "Please enter valid Blood Group.",
    excludeEmptyString: false,
  }),
  occupation: Yup.string().matches(
    /^[aA-zZ\s]+$/,
    "Give a Valid Occupation Type "
  ),
  gender: Yup.string(),
  personalNumber: Yup.string().matches(/^[6-9]\d{9}$/, {
    message: "Please enter Valid Mobile Number",
    excludeEmptyString: false,
  }),
  secondaryPhoneNumber: Yup.string().matches(/^[6-9]\d{9}$/, {
    message: "Please enter Valid Mobile Number",
    excludeEmptyString: false,
  }),
  fatherNumber: Yup.string().matches(/^[6-9]\d{9}$/, {
    message: "Please enter Valid Mobile Number",
    excludeEmptyString: false,
  }),
  aadharNumber: Yup.string().matches(
    /^\d{4}\d{4}\d{4}$/,
    "Invalid Aadhar Number"
  ),
  dateOfBirth: Yup.date()
  .required("DOB is Required")
  .test(
    "DOB",
    "Please choose a valid date of birth",
    (date) =>
      moment().diff(moment(date), "years") >= 12 &&
      moment().diff(moment(date), "years") <= 80
  ),
  pincode: Yup.string().matches(/^\d{2}\d{2}\d{2}$/, "Invalid PinCode Number"),
  bedId: Yup.string().required("Required"),
  addressLine1: Yup.string(),
  city: Yup.string().matches(/^[aA-zZ\s]+$/, "Invalid City Name"),
  addressLine2: Yup.string(),
  state: Yup.string().matches(/^[aA-zZ\s]+$/, "Invalid State "),
  buildingId: Yup.number().required("Required"),
  amountPaid: Yup.number().required("Required"),
  transactionId: Yup.string()
    .test(
      "len",
      "can be empty or with string at least 10 characters and not more than 30",
      (val) => {
        if (val == undefined) {
          return true;
        }
        return val.length == 0 || (val.length >= 10 && val.length <= 30);
      }
    )
    .required("Required"),

vehicleNo: Yup.string()
.test(
  "len",
  "can be empty or with string at least 8 characters and not more than 12",
  (val) => {
    if (val == undefined) {
      return true;
    }
    return val.length == 0 || (val.length >= 8 && val.length <= 12);
  }
),
});

const GuestLoginForm = (props) => {
  const navigate = useNavigate();
  const [building, setBuilding] = React.useState([]);
  const [oneBuilding, setoneBuilding] = React.useState([]);
  const [bed, setBed] = React.useState([]);
  const [availableBeds, setAvailableBeds] = React.useState([]);
  const [rent, setRent] = React.useState([]);
  const [duration, setDuration] = React.useState([]);
  const [defaultRentofBed, setDefaultRentofBed] = React.useState([]);
  const [secureDepo, setSecureDepo] = React.useState();
  const [buildId, setBuildId] = React.useState("");
  const [file, setFile] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [rentAmount, setRentAmount] = React.useState({});
  const [occupancyType, setOccupancyType] = React.useState({});
  const [sharing, setSharing] = React.useState(null);
  const [ratesId, setRatesId] = useState(null);
  const [roomType, setRoomType] = React.useState();
  const getAmount = (data) => {
    setRatesId(data.ratesConfigId);
    setSecureDepo(data.securityDeposit);
    setRentAmount(data.defaultRent);
    setOccupancyType(data.occupancyType);
    setDuration(data.duration);
    setSharing(data.sharing);
    if (data.roomType == "Ac") {
      setRoomType(true);
    } else {
      setRoomType(false);
    }
  };
  const INITIAL_FORM_STATE = {
    firstName: "",
    email: "",
    dateOfBirth: "",
    personalNumber: "",
    secondaryPhoneNumber: "",
    fatherName: "",
    fatherNumber: "",
    bloodGroup: "",
    occupation: "",
    gender: "",
    aadharNumber: "",
    buildingId: "",
    bedId: "",
    occupancyType: "",
    duration: "",
    amountPaid: "",
    transactionId: "",
    addressLine1: "",
    addressLine2: "",
    pincode: "",
    city: "",
    state: "",
    guestPicture: "",
    amountToBePaid: "",
    defaultRent: "",
    securityDeposit: "",
    checkinNotes: "",
    checkInDate: "",
    vehicleNo: "",
    packageId: ratesId,
  };
  let RegularTotal;
  RegularTotal = rentAmount + secureDepo;
  let oneMonthTotal;
  oneMonthTotal = rentAmount;
  let dailyTotal = rentAmount * duration;
  let TotalRent;
  if (occupancyType === regular) {
    TotalRent = RegularTotal;
  } else if (occupancyType === OneMonth) {
    TotalRent = oneMonthTotal;
  } else {
    TotalRent = dailyTotal;
  }
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  let buildingNamesArray = [];
  let availableBedsByBuidlingName = [];
  let empty = [];
  const classes = useStyles();
  let userData = JSON.parse(sessionStorage.getItem("userdata"));
  let userBuildingId = userData.data.buildingId;
  let userType = userData.data.userType;
  var userID = userData.data.userId;
  function securityDepoist() {
    axios
      .get("guest/getSecurityDepositByOccupancyType/Regular")
      .then((rse) => console.log(rse.data.securityDepositAmount));
  }
  useEffect(() => {
    axios
      .get("/bed/getAvailableBedsByBuildings")
      .then((res) => {
        setoneBuilding(res.data);
        res.data.map((data) => {
          if (userBuildingId === data.buildingId) {
            buildingNamesArray.push(data.buildingName);
            console.log(buildingNamesArray);
          }
          //  else {
          //  toast.warn("Building not selected")
          // }
        });
        setBuilding(buildingNamesArray);
      })
      .catch((err) => {
        toast.error("Something went wrong!")
      });
  }, []);
  var obje1 = oneBuilding.reduce(function (acc, cur, i) {
    acc[cur.buildingId] = cur.buildingName;
    return acc;
  }, {});
  const notify = () => toast();
  const handleClick = (id) => {
    if (userType !== "manager") {
      bid = id.target.dataset.value;
      setBuildId(bid);
    } else {
      bid = userBuildingId;
      setBuildId(bid);
    }
    const bool = oneBuilding.filter(
      (buildingData) => buildingData.buildingName == id.target.outerText
    );
    bool.map((bed) => setAvailableBeds(bed.beds));
  };
  availableBeds.map((item) => {
    if (item.sharing == sharing && item.ac == roomType) {
      availableBedsByBuidlingName.push(item.bedId);
    } else {
     const bedSharingStatus = false;
    }
  });
  if (availableBedsByBuidlingName === null) {
    toast.error("Selected sharing beds are not available");
  }
  console.log(availableBedsByBuidlingName);
  const selectBed = (e) => {
    securityDepoist();
    setBed(e.target.outerText);
    const bedRent = availableBeds.filter(
      (bed) => bed.bedId == e.target.outerText
    );
    bedRent.map((post) => {
      setRent(post.defaultRent);
      setDefaultRentofBed(post.defaultRent);
    });
  };
  const OnBoarding = "OnBoarding";
  const obj = {
    bedId: bed,
    createdBy: userID,
    defaultRent: rentAmount,
    securityDeposit: secureDepo,
    amountToBePaid: TotalRent,
    paymentPurpose: OnBoarding,
    buildingId: buildId,
    occupancyType: occupancyType,
    sharing: sharing,
    duration: duration,
    packageId: ratesId,
  };
  const amountNeedToPay = (n) => {};
  function handleChooseGuestPicture(event) {
    setFile(event.target.files[0]);
    if (event.target.files[0].size >= 1000000) {
      toast.warning("Please select file with less than 1 MB");
    }
  }
  return (
    <div>
      <Typography>
        <br />
        <h4 style={{ paddingLeft: "525px" }}>Occupancy Type</h4>
        <br />
      </Typography>
      <Grid item xs={12} paddingLeft={-4} paddingTop={2}>
        <div>
          <CustomizedButtons func={getAmount} buildingId={userBuildingId} />
        </div>
      </Grid>
      <Grid container onClick={handleClose}>
        <Grid item xs={12}>
          <Container maxWidth="md">
            <div>
              <Formik
                initialValues={{ ...INITIAL_FORM_STATE }}
                validationSchema={FORM_VALIDATION}
                onSubmit={async (guest, { resetForm }, empty) => {
                  handleToggle();
                  const gustes = Object.assign(guest, obj);
                  try {
                    if (gustes.amountPaid == TotalRent) {
                      const res = await axios
                        .post("/guest/addGuest", gustes)
                        .then((res) => {
                          if (res.data.id !== null) {
                            handleClose();
                            toast.success(" Guest onboarded successfully");
                            resetForm();
                            empty;
                            const url = `guest/upload/${res.data.id}/`;
                            const formData = new FormData();
                            if (file !== null) {
                              console.log(file);
                              formData.append("file", file);
                              formData.append("fileName", file.name);
                              const config = {
                                headers: {
                                  "content-type": "multipart/form-data",
                                },
                              };
                              axios
                                .post(url, formData, config)
                                .then((response) => {
                                  toast.success(
                                    "guest picture uploaded successfully"
                                  );
                                })
                                .catch((error) => {
                                  toast.error("Not uploaded");
                                });
                            } else {
                              toast.warning(" Picture is Not Uploaded")
                            }
                            setTimeout(() => {
                              navigate("/tracker");
                            }, 4000);
                          } else {
                          toast.error("")
                          }
                        });
                    } else {
                      handleClose();
                      toast.error(" Need to pay full Amount");
                    }
                  } catch (error) {
                    handleClose();
                    toast.error("Something went wrong !");
                  }
                }}
              >
                {(formProps) => (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography>
                          <br />
                          <h4 align="center">Allocate Room</h4>
                          <br />
                        </Typography>
                        <InputLabel id="demo-simple-select-labe">
                          {" "}
                          * Indicates fields are Required
                        </InputLabel>
                        <br />
                      </Grid>
                      {userType !== "manager" ? (
                        <Grid item xs={6}>
                          <h6>Select Building *</h6>
                          <Select
                            IconComponent={() => (
                              <ArrowDropDownIcon className={classes.size} />
                            )}
                            className={classes.root}
                            name="buildingId"
                            options={obje1}
                            onClick={handleClick}
                            required
                          ></Select>
                          <Grid item xs={6}></Grid>
                        </Grid>
                      ) : (
                        <Grid item xs={6}>
                          <h6>Select Building *</h6>
                          <Select
                            IconComponent={() => (
                              <ArrowDropDownIcon className={classes.size} />
                            )}
                            className={classes.root}
                            name="buildingId"
                            options={building}
                            onClick={handleClick}
                            required
                          ></Select>
                          <Grid item xs={6}></Grid>
                        </Grid>
                      )}
                      <Grid item xs={6}>
                        <h6>Select Bed *</h6>
                        <Select
                          IconComponent={() => (
                            <ArrowDropDownIcon className={classes.size} />
                          )}
                          className={classes.root}
                          name="bedId"
                          options={availableBedsByBuidlingName}
                          onClick={selectBed}
                        ></Select>
                      </Grid>
                      <Grid item xs={6}>
                        <h6>CheckIn Date* </h6>
                        <DateTimePicker
                          mindate={new Date()}
                          name="checkInDate"
                          required
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>
                          <br />
                          <h4 align="center">Booking/Payment Details</h4>
                          <br />
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Amount Paid *</h6>
                        <Textfield
                          name="amountPaid"
                          required
                          onClick={amountNeedToPay}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Transaction ID *</h6>
                        <Textfield
                          name="transactionId"
                          required
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>
                          <br />
                          <h4 align="center">Guest's Personal Information</h4>
                          <br />
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Guest Name *</h6>
                        <Textfield
                          name="firstName"
                          required
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Email </h6>
                        <Textfield
                          name="email"
                          required
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Date of Birth *</h6>
                        <DateTimePicker
                          maxdate={new Date()}
                          name="dateOfBirth"
                          required
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Personal Phone *</h6>
                        <Textfield
                          name="personalNumber"
                          required
                        />

                      </Grid>

                      <Grid item xs={6}>
                      <h6>Vehicle  Number</h6>
                        <Textfield name="vehicleNo" />

                      </Grid>
                      <Grid item xs={6}>
                        <h6>Secondary Phone</h6>
                        <Textfield name="secondaryPhoneNumber" />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Father's Name</h6>
                        <Textfield name="fatherName" />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Father's Phone</h6>
                        <Textfield name="fatherNumber" />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Blood Group</h6>
                        <Textfield name="bloodGroup" />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Occupation</h6>
                        <Textfield name="occupation" />
                      </Grid>
                      <br />
                      <Grid item xs={6}>
                        <h6>Select Gender *</h6>
                        <Select
                          IconComponent={() => (
                            <ArrowDropDownIcon className={classes.size} />
                          )}
                          name="gender"
                          options={Gender}
                          className={classes.root}
                        ></Select>
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Aadhar Number *</h6>
                        <Textfield name="aadharNumber" required />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Guest Picture</h6>
                        <input
                          type="file"
                          onChange={handleChooseGuestPicture}
                        />
                      </Grid>
                      <Grid item xs={12} />
                      <Grid item xs={12}>
                        <Typography>
                          <h4 align="center">Permanent Address</h4>
                          <br />
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <h6>Address Line 1 *</h6>
                        <Textfield name="addressLine1" required />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Address Line 2</h6>
                        <Textfield name="addressLine2" />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Pincode *</h6>
                        <Textfield name="pincode" required />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>City *</h6>
                        <Textfield name="city" required />
                      </Grid>
                      <Grid item xs={6}>
                        <h6>Select state *</h6>
                        <Select
                          IconComponent={(Gender) => (
                            <ArrowDropDownIcon className={classes.size} />
                          )}
                          name="state"
                          options={state}
                          className={classes.root}
                        ></Select>
                      </Grid>
                      <Grid item xs={12}>
                        <h6>Check-in Notes</h6>
                        <Textfield name="checkinNotes" multiline rows={3} />
                      </Grid>
                      <Grid item xs={3} sx={{ paddingBottom: 3 }}>
                        <Button onClick={notify}>Submit</Button>
                      </Grid>
                    </Grid>
                    <ToastContainer
                      position="top-right"
                      min-width="2%"
                      autoClose={3000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </Container>
        </Grid>
      </Grid>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
export default GuestLoginForm;
